import React from 'react';
import PropTypes from 'prop-types';
import ArrowLeft from '../Icons/ArrowLeft';
import ArrowRight from '../Icons/ArrowRight';
import { StyledChevron } from './TrainMapStyled';
import { ChevronDirection } from '../seatMapConstants';

const scrollAmount = 300;

const TrainMapArrow = ({ direction, ...rest }) => {
  switch (direction) {
    case ChevronDirection.LEFT:
      return <ArrowLeft {...rest} />;
    case ChevronDirection.RIGHT:
      return <ArrowRight {...rest} />;
    default:
      return null;
  }
};

TrainMapArrow.propTypes = {
  direction: PropTypes.oneOf([ChevronDirection.LEFT, ChevronDirection.RIGHT]).isRequired,
};

const TrainMapArrows = ({ chevronsDisabled, isDoubleDecker }) => {
  const scrollTrainMap = (direction) => {
    const trainMapElement = document.querySelector('#train-map-scroll');
    const scrollOffset = direction === 'right' ? scrollAmount : -scrollAmount;
    const newPosition = (trainMapElement?.scrollLeft ?? 0) + scrollOffset;
    trainMapElement?.scroll({ left: newPosition, behavior: 'smooth' });
  };

  return (
    <>
      {[ChevronDirection.LEFT, ChevronDirection.RIGHT].map((direction) => (
        <StyledChevron
          key={direction}
          isDoubleDecker={isDoubleDecker}
          onClick={() => scrollTrainMap(direction)}
          className={`${direction} ${chevronsDisabled[direction] ? 'disabled' : ''}`}
        >
          <TrainMapArrow width={24} height={24} direction={direction} />
        </StyledChevron>
      ))}
    </>
  );
};

TrainMapArrows.propTypes = {
  chevronsDisabled: PropTypes.object.isRequired,
  isDoubleDecker: PropTypes.bool.isRequired,
};

export default TrainMapArrows;
